import script from "./notification-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./notification-card.vue?vue&type=script&setup=true&lang=ts"

import "./notification-card.vue?vue&type=style&index=0&id=5ee71f48&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ee71f48"]])

export default __exports__